import { getEmbedsFromData } from '@client/listeners/lib/requests';
import { getStreamingProfileDetails } from '@sda/utils/url';
import type { Writable } from 'type-fest';
import type { Act } from '@sda/interfaces/act';
import type { CreateActPayload } from '@sda/interfaces/reducer/acts.reducer';

export const getEmbedData = async (data: Partial<Pick<CreateActPayload, 'videoUri' | 'audioUri'>>): ReturnType<typeof getEmbedsFromData> => {
  let actData: Writable<Partial<Act>> = {
    bandcampUri: null,
    bandcampUriCache: null,
    soundcloudUri: null,
    soundcloudUriCache: null,
    spotifyUri: null,
    spotifyUriCache: null,
    youtubeUri: null,
    youtubeUriCache: null,
    vimeoUri: null,
    vimeoUriCache: null,
  };

  if (data.audioUri) {
    const urlData = getStreamingProfileDetails(data.audioUri);

    if (urlData?.service === 'soundcloud') {
      actData.soundcloudUri = data.audioUri;
    } else if (urlData?.service === 'bandcamp') {
      actData.bandcampUri = data.audioUri;
    } else if (urlData?.service === 'spotify') {
      actData.spotifyUri = data.audioUri;
    }
  }

  if (data.videoUri) {
    const urlData = getStreamingProfileDetails(data.videoUri);

    if (urlData?.service === 'youtube') {
      actData.youtubeUri = data.videoUri;
    } else if (urlData?.service === 'vimeo') {
      actData.vimeoUri = data.videoUri;
    }
  }

  return {
    ...actData,
    ...await getEmbedsFromData(actData),
  };
};
